export default function Logo({ size = 48, className = "" }) {
  return (
    <img
      src="/images/pogo-logo.webp"
      alt="POSSO"
      data-testid="pogo-logo"
      width={size}
      height={size}
      className={`rounded-full select-none ${className}`}
      draggable="false"
    />
  );
}
